import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { categoryMaster } from 'src/app/Models/BasicForms/categoryMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-category-master',
  templateUrl: './category-master.component.html',
  styleUrls: ['./category-master.component.css']
})

export class CategoryMasterComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Category";

  ngOnInit(): void {
    this.getAllCategory();

    this.logtext = 'OPENED - Category Master form KEYWORD[O - Category Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["NAME", "Category"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  categoryData: [];

  getAllCategory(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Category Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Category Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Category Master form "+ likeQuery +" KEYWORD [F - Category Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    var filter = ""
    if (likeQuery)
      filter = this.filterQuery + likeQuery
    else
      filter = this.filterQuery


    this.isloadSpinning = true

    this._apiService.getAllCategories(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.categoryData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  categoryDrawerData: categoryMaster = new categoryMaster();

  add() {
    this.drawerVisible = true;
    this.drawerTitle = "Create Category";
    this.categoryDrawerData = new categoryMaster();
    this.categoryDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Category Master form KEYWORD [A - Category Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: categoryMaster) {
    this.drawerVisible = true;
    this.drawerTitle = "Update Category";
    this.categoryDrawerData = Object.assign({}, data);

    this.logtext = 'EDIT - Category Master form KEYWORD [E - Category Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllCategory();
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllCategory();
  }
}
